import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { InfrastructureService } from 'src/app/@core/services/infrastructure/infrastructure.service';
import { Infrastructure } from 'src/app/@core/models/infrastructure/Infrastructure.model';
import { Organization } from 'src/app/@core/models/infrastructure/Organization.model';
import { AppService } from 'src/app/@core/services/app/app.service';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';


@Component({
  selector: 'app-org-infra',
  templateUrl: './org-infra.component.html',
  styleUrls: ['./org-infra.component.scss'],
})
export class OrgInfraComponent implements OnInit, OnChanges {
  @Input() organization: Organization;
  @Input() infrastructure: Infrastructure;
  onlyRead: boolean;

  constructor(
    public infraService: InfrastructureService,
    private appService: AppService,
    public darkModeService: DarkModeService
  ) {}

  ngOnInit(): void {
    this.getUserAdminsOrg()
  }

  ngOnChanges(): void {
    this.getUserAdminsOrg()
  }

  getUserAdminsOrg(){
    const loading = this.appService.openLoading();
    this.infraService.getAdminsUsersOrg(this.organization).subscribe(organization => {
      this.organization = organization;
      loading.close();
    });
  }

}
